import React from 'react'

export const About = () => {
    return (
        <div>
            <p>Hi there! My name is Sieder and I'm a React developer. I enjoy exploring other frameworks during my free time.</p>
        </div>
    )
}